import { Link } from "react-router-dom";
import { ArrowRight, Package } from "lucide-react";
import { buildQuoteUrl } from "@/config/site";
import ProductImage from "@/components/ProductImage";

export default function ProductCard({ product }) {
  return (
    <article
      className="group bg-white border border-neutral-200 flex flex-col transition-all duration-200 hover:-translate-y-0.5 hover:shadow-md rounded-sm overflow-hidden"
      data-testid={`product-card-${product.slug}`}
    >
      <div className="relative aspect-[4/3] bg-neutral-100 border-b border-neutral-200 overflow-hidden">
        <ProductImage product={product} className="absolute inset-0 h-full w-full object-cover" />
        <div className="absolute top-3 left-3 text-[10px] uppercase tracking-[0.18em] text-neutral-500 bg-white/90 px-2 py-1 border border-neutral-200">
          {product.category}
        </div>
      </div>
      <div className="p-5 flex-1 flex flex-col">
        <h3 className="font-heading text-lg font-semibold tracking-tight text-neutral-900">
          {product.name}
        </h3>
        <p className="mt-2 text-sm text-neutral-600 leading-relaxed flex-1">
          {product.shortDescription}
        </p>
        {product.tags && product.tags.length ? (
          <div className="mt-3 flex flex-wrap gap-1.5">
            {product.tags.map((t) => (
              <span key={t} className="text-[10px] uppercase tracking-[0.15em] text-neutral-600 border border-neutral-300 px-2 py-0.5">
                {t}
              </span>
            ))}
          </div>
        ) : null}
        <div className="mt-5 pt-4 border-t border-neutral-100 flex items-center justify-between gap-3">
          <Link
            to={`/products/${product.slug}`}
            className="text-sm font-medium text-neutral-900 inline-flex items-center gap-1 hover:text-[#A91D22]"
            data-testid={`view-product-${product.slug}`}
          >
            View Product <ArrowRight size={14} className="transition-transform group-hover:translate-x-0.5" />
          </Link>
          <a
            href={buildQuoteUrl(product.name)}
            target="_blank"
            rel="noopener noreferrer"
            className="text-sm font-medium text-[#A91D22] hover:text-[#8B181C]"
            data-testid={`quote-product-${product.slug}`}
          >
            Request Quote
          </a>
        </div>
      </div>
    </article>
  );
}
